import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import Icon from "ds/components/Icon";
import { RUN_PRIORITY_PRESET_ORDER, RUN_PRIORITY_PRESETS } from "shared/Run/priorityPresets";
import { RunPriorityPreset } from "types/generated";
import { AccessResult } from "utils/access";
import { withTestId } from "utils/withTestId";

import { RUN_PRIORITY_MENU_ITEM_TEST_ID } from "./constants";
import styles from "./styles.module.css";

type RunPriorityMenuItemsProps = {
  current: RunPriorityPreset;
  onSelect: (preset: RunPriorityPreset) => void;
  canPrioritize: AccessResult;
};

const RunPriorityMenuItems = ({ current, onSelect, canPrioritize }: RunPriorityMenuItemsProps) => (
  <>
    {RUN_PRIORITY_PRESET_ORDER.map((preset) => {
      const { icon, color, label } = RUN_PRIORITY_PRESETS[preset];
      const isCurrent = preset === current;

      return (
        <DropdownMenuItem
          key={preset}
          className={styles.item}
          active={isCurrent}
          isDisabled={!canPrioritize.result}
          tooltip={canPrioritize.message}
          onAction={isCurrent ? undefined : () => onSelect(preset)}
          {...withTestId(`${RUN_PRIORITY_MENU_ITEM_TEST_ID}-${preset}`)}
        >
          <Icon src={icon} color={color} />
          {label}
        </DropdownMenuItem>
      );
    })}
  </>
);

export default RunPriorityMenuItems;
